<template>
    <div style="height: 100vh;width: 100vw;">
      <el-button type="primary"  @click="refreshPosition" size="small">
        实时点位
      </el-button>
      <div id="amapcontainer"></div>
    </div>
  </template>
  
  <script>
  import {getSmartDeviceDataLocation } from '@/api/nursingHome/elderDevice';
  export default {
    props: {
    row: {
      default: {},
    },
    
  },
    data() {
      return {
        map:{},
        mouseTool:{},
        path : [
        // new AMap.LngLat(114.538827,30.491971),
        // new AMap.LngLat(114.542009,30.492739),
        // new AMap.LngLat(114.541537,30.490539),
        // new AMap.LngLat(114.538104,30.490687)
        ],
        position:{},
        gpsCurrentLocation:[],
        marker:{}
      }
    },
    created(){
      console.log("this.path",this.path)
     
    },
    mounted() {
      this.initData()
   
    },
    methods: {
     
      initAMap () {
        let vm = this
        let position =[]
        if(vm.gpsCurrentLocation.length>0){
          position= [vm.gpsCurrentLocation[0],vm.gpsCurrentLocation[1]]
          
        }else{
          position =[116.397428, 39.90923]
        }
        this. map = new AMap.Map('amapcontainer', {
                zoom: 17,//级别 3-17  越大显示越细节
                 center:position,//中心点坐标
                // center: [116.397428, 39.90923],  //设置地图中心点坐标
   
                // viewMode: '2D'//使用3D视图
           });
        //实时路况图层
      	var trafficLayer = new AMap.TileLayer.Traffic({
             zIndex: 10
        });
        this.map.add(trafficLayer);//添加图层到地图
        console.log("****",this.path)
        var Polygon = new AMap.Polygon({
            path: this.path,  
            fillColor: '#fff', // 多边形填充颜色
            borderWeight: 4, // 线条宽度，默认为 1
            strokeColor: 'red', // 线条颜色
        });
        this.map.add(Polygon);

       if(vm.gpsCurrentLocation.length>0){
        this. marker = new AMap.Marker({
        position: new AMap.LngLat(vm.gpsCurrentLocation[0],vm.gpsCurrentLocation[1]),
        // offset: new AMap.Pixel(-10, -10),
        //  icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_rs.png', // 添加 Icon 图标 URL
       
        title: '设备'
        });
        this. map.add(this. marker);
       }
       

    },
    refreshPosition(){
      getSmartDeviceDataLocation({id: this.row.id}).then((res) => {
        if(res.data.gpsCurrentLocation!=""){
          this. gpsCurrentLocation = res.data.gpsCurrentLocation.split(",")
        }else{
          this. gpsCurrentLocation = []
        }
        this.map.remove(this.marker);
        if(this.gpsCurrentLocation.length>0){
        this. marker = new AMap.Marker({
        position: new AMap.LngLat(this.gpsCurrentLocation[0],this.gpsCurrentLocation[1]),
        
       
        title: '设备'
        });
        this. map.add(this. marker);
      }
      })
    },
    initData(){
      getSmartDeviceDataLocation({id: this.row.id}).then((res) => {
        let path =res.data.gpsFence.split(";")
        console.log(path)
        for(let i=0;i<path.length;i++){
          this.path.push(new AMap.LngLat(path[i].split(",")[0],path[i].split(",")[1]))
        }
        if(res.data.gpsCurrentLocation!=""){
          this. gpsCurrentLocation = res.data.gpsCurrentLocation.split(",")
        }else{
          this. gpsCurrentLocation = []
        }
          
      
   
       this.initAMap()
      })
    },
    }
  }
</script>
<style  scoped>

#amapcontainer {
  width: 100%;
  height: 100%;
}

</style>